import {
	HomeSingleProductDisplayRule,
	HomeSingleProductSubmissionRule,
	HomeSuggestedProductAvailabilityRule,
} from '../interfaces';

export const homeSingleProductQuantityValidationRule: HomeSingleProductSubmissionRule = context => ({
	...context,
	isQuantityValid: Number.parseInt(String(context.quantity ?? 0), 10) > 0,
});

export const homeSingleProductActiveModifierCountsRule: HomeSingleProductSubmissionRule = context => ({
	...context,
	activeModifierCounts: context.modifierGroups.map(
		group => group?.detallesmodificadores.filter(detail => detail.addExtra).length ?? 0
	),
});

export const homeSingleProductModifierMinimumRule: HomeSingleProductSubmissionRule = context => ({
	...context,
	hasUnmetModifierMinimum: context.modifierGroups.some(
		(group, index) => !!group && group.minimo > context.activeModifierCounts[index]
	),
});

export const homeSingleProductSubmissionRule: HomeSingleProductSubmissionRule = context => ({
	...context,
	isDisabled: !context.isQuantityValid || context.hasUnmetModifierMinimum,
});

export const homeSingleProductModifierGroupsRule: HomeSingleProductDisplayRule = context => ({
	...context,
	hasModifierGroups: context.modifierGroupCount > 0,
});

export const homeSingleProductMultiplePricesRule: HomeSingleProductDisplayRule = context => ({
	...context,
	hasMultiplePrices: context.priceCount > 1,
});

export const homeSingleProductLongModeRule: HomeSingleProductDisplayRule = context => ({
	...context,
	isLongMode: context.hasModifierGroups || context.hasMultiplePrices,
});

export const homeSuggestedProductAvailabilityRule: HomeSuggestedProductAvailabilityRule = context => ({
	...context,
	isAvailable: context.stock === null || context.stock === undefined || context.stock > 0,
});

export const homeSuggestedProductStockRule: HomeSuggestedProductAvailabilityRule = context => ({
	...context,
	isOutOfStock: !context.isAvailable,
});
